import { useQuery } from '@tanstack/react-query';
import { CheckupRequestStatusResponse } from '@companion-professional/dctypes';
import { getCheckupsForPet } from '../lib/api';
import { getAnalysisStatusForGait } from './getAnalysisStatusForGait';
import { useCheckupItemAnalysis } from './useCheckupItemAnalysis';
import { useEffect } from 'react';
import { useState } from 'react';

// useCheckupsForPet is a hook that fetches the checkups for a given pet.
// It returns:
// - isPending: A boolean that indicates if the request is currently in progress.
// - error: An error object if the request failed.
// - checkups: An array of CheckupRequestStatusResponse objects.
export const useCheckupsForPet = (petId: string) => {
  const { checkupItemAnalysisResults, isPending: mlResultsPending } = useCheckupItemAnalysis();
  const [checkupsWithAnalysisStatus, setCheckupsWithAnalysisStatus] = useState<CheckupRequestStatusResponse[]>([]);
  const {
    isPending,
    error,
    data: checkups
  } = useQuery<CheckupRequestStatusResponse[]>({
    queryKey: ['pet-checkups', petId],
    queryFn: () => getCheckupsForPet(petId)
  });

  useEffect(() => {
    if (checkups && checkupItemAnalysisResults && !mlResultsPending) {
      setCheckupsWithAnalysisStatus(
        checkups.map((checkup) => (
          { ...checkup, analysis_status: getAnalysisStatusForGait(checkupItemAnalysisResults, checkup.id) }
        )));
    }
  }, [checkups, checkupItemAnalysisResults, mlResultsPending]);

  return {
    isPending,
    error,
    checkups: checkupsWithAnalysisStatus
  };
};
